import AnimatedText from "../components/AnimatedText";

import "../styles/latest.css";
import VoteSteppin from "../components/VoteSteppin";

const Latest = () => {
  return (
    <section id="latest">
      <div className="container">


        <VoteSteppin />


      </div>
    </section>
  );
};

export default Latest;
